import { Component } from '@angular/core';
import { ManagementService } from '../../services/management.service';

@Component({
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrl: './countries.component.scss',
})
export class CountriesComponent {
  searchTerm = '';
  showRegisterModal: boolean = false;
  showEditModal: boolean = false;
  showRegisterCityModal: boolean = false;
  showEditCityModal: boolean = false;
  isLoading: boolean = true;
  selectedCountryId: number | null = null;
  selectedCityId: number | null = null;
  searchTimeout: any;

  countriesData: any[] = [];

  constructor(private managementService: ManagementService) {}

  ngOnInit(): void {
    this.filterData();
  }

  filterData(): void {
    this.isLoading = true;

    const filters = {
      search: this.searchTerm,
    };

    this.managementService.postListCountries(filters).subscribe({
      next: (data: any[]) => {
        this.countriesData = data.sort((a, b) =>
          a.countryName.localeCompare(b.countryName)
        );

        this.countriesData.forEach((country) => {
          if (country.cities && country.cities.length > 0) {
            country.cities.sort((a: any, b: any) =>
              a.cityName.localeCompare(b.cityName)
            );
          }
        });

        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error al obtener los datos:', err);
      },
    });
  }

  onDialogClose() {
    this.showRegisterModal = false;
    this.showEditModal = false;
    this.selectedCountryId = null;
  }

  onDialogCityClose() {
    this.showRegisterCityModal = false;
    this.showEditCityModal = false;
    this.selectedCountryId = null;
    this.selectedCityId = null;
  }

  onSearch(query: string): void {
    this.searchTerm = query;

    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      if (this.searchTerm.length >= 3 || this.searchTerm.length === 0) {
        this.filterData();
      }
    }, 300);
  }

  onRegisterComplete(): void {
    this.filterData();
  }

  onEditComplete(): void {
    this.filterData();
  }

  onRegisterCityComplete(): void {
    this.filterData();
  }

  onEditCityComplete(): void {
    this.filterData();
  }

  onNewRegisterCountry(): void {
    this.showRegisterModal = true;
  }

  onNewRegisterCity(countryItem: any): void {
    if (!countryItem?.countryId) {
      console.error('El item no contiene countryId', countryItem);
      return;
    }

    this.selectedCountryId = countryItem.countryId;
    this.showRegisterCityModal = true;
  }

  onEditCountry(countryItem: any): void {
    if (!countryItem?.countryId) {
      console.error('El item no contiene countryId', countryItem);
      return;
    }

    this.selectedCountryId = countryItem.countryId;
    this.showEditModal = true;
  }

  onEditCity(countryItem: any): void {
    if (!countryItem?.item) {
      console.error('El item no contiene countryId', countryItem);
      return;
    }

    this.selectedCountryId = countryItem.item.countryId;
    this.selectedCityId = countryItem.subitem.cityId;
    this.showEditCityModal = true;
  }
}
